// Phase 4 — Investor capital profile constants. Mirrors INVESTOR_INTERESTS / INVESTOR_RISK / INVESTOR_HORIZON in backend.
import { Layers, Mountain, Briefcase, Coins, Compass, Sprout } from "lucide-react";

export const INVESTOR_INTEREST_TAGS = [
    { id: "land_jv", label: "Land Joint Ventures", icon: Layers, accent: "text-coral", desc: "Land owners contribute land for equity in tourism / agri / mixed-use projects." },
    { id: "direct_land", label: "Direct land purchase", icon: Mountain, accent: "text-fiji-green", desc: "Outright land buys — freehold or long-term lease." },
    { id: "business_buyout", label: "Business buyouts", icon: Briefcase, accent: "text-ocean dark:text-turquoise", desc: "Acquire a Fiji-based business outright (NDA-gated financials)." },
    { id: "passive_equity", label: "Passive equity", icon: Coins, accent: "text-coral", desc: "Silent partner in approved Joint Ventures — capital only, operator runs the project." },
    { id: "tourism", label: "Tourism / hospitality", icon: Compass, accent: "text-fiji-green", desc: "Resorts, dive shops, eco-lodges, retreats." },
    { id: "agriculture", label: "Agriculture", icon: Sprout, accent: "text-fiji-green", desc: "Kava, copra, taro, fishing, exports." },
];

export const RISK_PROFILES = [
    { id: "conservative", label: "Conservative", desc: "Income-focused, lower risk." },
    { id: "balanced", label: "Balanced", desc: "Mix of growth + income." },
    { id: "aggressive", label: "Aggressive", desc: "Growth-focused, Joint Venture equity." },
];

export const HORIZONS = [
    { id: "short", label: "Short (<3 yrs)" },
    { id: "medium", label: "Medium (3–7 yrs)" },
    { id: "long", label: "Long (7+ yrs)" },
];
